import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType;
};
